export default __webpack_public_path__ + "static/media/megaphone.c7e03a4f.svg";